import PropTypes from 'prop-types';
import React from 'react';
import RenderComponentProto from '../../render-component-proto';

import SelectUser from '../../../../gd-ui/select-user/select-user';

import Classes from 'classnames';

class UserComponentProto extends RenderComponentProto {

    constructor(props) {
        super(props);

        this.state = {
            value: props.value === "None" ? null : props.value, //temp fix for "None" value in customFieldData
        };

        this._bind('onChange');
    }

    onChange(newValue) {
        this.setState({value: newValue}, () => {
            if (this.props.onChange) this.props.onChange(newValue);
        });
    }

    render() {
        const { id, renderMode, canEdit } = this.props;
        const { value } = this.state;
        const classes = Classes('gd-field-user', renderMode, {
            'disabled': canEdit === false,
            'not-set': !value
        });

        const customField = gd.session.customFields.get(id)
        const options = []
        _.map(gd.session.companyUsers.filterByCompany(customField.companyId).models, cu=>{
            if (cu?.user) options.push(cu.user.id)
        });

        const underlined = renderMode === 'form-new' ? "always" : "on-hover";

        return (
            <SelectUser className={classes}
                        value={value}
                        options={options}
                        renderValue="icon-name"
                        onUserSelect={this.onChange}
                        underlined={underlined}
                        disabled={canEdit === false}
                        placeholder="No user"
                        canHaveNoValue={true}
                        noValueValue={null}
                        noValueLabel="No user"
                        avatarSize='22'
            />
        );
    }

}


UserComponentProto.propTypes = {
    id: PropTypes.string.isRequired,
    renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
    value: PropTypes.any,
    canEdit: PropTypes.bool,
    onChange: PropTypes.func,
};

UserComponentProto.defaultProps = {
    canEdit: false,
};

module.exports = UserComponentProto;